import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const CandidateSeating = React.lazy(() => import("@/pages/onBoarding/siteAdmin/Index"));

const CandidateSeatingRouter = [
  {
    path: "candidateSeating",
    element: (
      <SuspenseWrapper>
        <CandidateSeating />
      </SuspenseWrapper>
    ),
  },
];

export default CandidateSeatingRouter;
